export default {"src":"/_next/static/media/clock.061ecbbc.svg","height":14,"width":12,"blurWidth":0,"blurHeight":0};